export default "__VITE_ASSET__7190a63e__"